import { REFRESH_MENU_ORDER } from "../types";

const initialState = {
  canRefreshMenu: false,
};

export default (state = initialState, action) => {
  // console.log(" Refresh menu order action ")
  switch (action.type) {
    case REFRESH_MENU_ORDER:
      return {
        ...state,
        canRefreshMenu: action.payload,
      };

    default:
      return state;
  }
};
